import { useEffect } from "react";
import { withAppContext } from "src/store/initAppContext";
import styled, { withTheme } from "styled-components";
import config from "src/config/config";
// import { theme } from "styled-tools";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import PlaceholderImage from 'src/components/Placeholder';

function Place9BetsWinUpTo99XPromoFun(props: any) {
    const {
        app: { brandId },
        theme,
    } = props;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const games = [
        {
            name: "Monopoly Roulette",
            image: theme.image.ChooseYrGmeMonopolyRouletteImage,
            link: "/live-casino/evolution/monopoly-roulette",
        },
        {
            name: "Red Baron",
            image: theme.image.ChooseYrGmeRedBaronImage,
            link: "/instant-games/evolution/red-baron",
        },
        {
            name: "Ice Fishing",
            image: theme.image.ChooseYrGmeIceFishingImage,
            link: "/live-casino/evolution/ice-fishing",
        },
    ];

    // function getDomain(brandId: any) {
    //     if ([31, 32, 61, 35, 36].includes(brandId)) return "Yolo247";
    //     if ([37, 39, 40].includes(brandId)) return "Fomo7";
    //     if ([46, 47, 49].includes(brandId)) return "Fun88";
    //     return "Iw247";
    // }
    // const domainName = getDomain(brandId);
    const isPK = brandId && (brandId === 35 || brandId === 36 || brandId === 37 || brandId === 49);
    const maxWinningAmt = (brandId === 61) ? "$5265.89" : isPK ? "PKR 15,00,000" : "₹5,00,000";
    const minQualifyingBetAmt = (brandId === 61) ? "$0.53" : isPK ? "PKR 150" : "₹50";

    return (
        <>
            <InformationWrapper>
                {/* =========================
                    TOP CONTENT
                ========================== */}
                <TopSection>
                    <h1>3 GAMES. 3 GUARANTEED WINS. NO LUCK REQUIRED.</h1>

                    <p className="top-para">
                        Play your favourite Evolution games and complete 9 qualifying bets for a guaranteed reward of up to 99x 
                        <br className="desktop-break" />
                        your qualifying bet — with a chance to win on every one of the 3 participating games.
                    </p>

                    <p className="promotion-period">
                        Promotion Period:{" "}
                        <strong>1 September – 31 October 2026</strong>
                    </p>
                </TopSection>

                {/* =========================
                    CHOOSE YOUR GAME
                ========================== */}
                <Section>
                    <h2>Choose Your Game</h2>

                    <p className="section-description">
                        Complete 9 qualifying bets on each participating game to unlock a reward.
                    </p>

                    <GamesWrapper>
                        {games.map((game) => (
                            <GameLink
                                key={game.name}
                                href={game.link}
                                aria-label={`Play ${game.name}`}
                            >
                                <LazyLoadImage
                                    src={`${config.imageV3Host}/static/cashsite/${game.image}`}
                                    alt={game.name}
                                    effect="none"
                                    placeholder={<PlaceholderImage />}
                                />
                            </GameLink>
                        ))}
                    </GamesWrapper>
                </Section>

                {/* =========================
                    HOW TO CLAIM
                ========================== */}
                <Section>
                    <h2>How To Claim</h2>

                    <ImageWrapper>
                        <LazyLoadImage
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.Place9BetsWinUpTo99XHowToClaimImage}`}
                            alt="How To Claim"
                            effect="none"
                            placeholder={<PlaceholderImage />}
                        />
                    </ImageWrapper>
                </Section>

                {/* =========================
                    TERMS & CONDITIONS
                ========================== */}
                <Section>
                    <h2>Terms & Conditions</h2>

                    <TermsList>
                        <li>
                            Promotion Is Valid From{" "}
                            <strong>1 September To 31 October 2026.</strong>
                        </li>

                        <li>
                            Participating Games:{" "}
                            <strong>
                                Monopoly Roulette, Red Baron And Ice Fishing.
                            </strong>
                        </li>

                        <li>
                            The Minimum Qualifying Bet Is{" "}
                            <strong>{minQualifyingBetAmt} Per Bet.</strong>
                        </li>

                        <li>
                            The Maximum Winnings Are{" "}
                            <strong>{maxWinningAmt} Per Participating Game.</strong>
                        </li>

                        <li>
                            Players Can Win{" "}
                            <strong>Once Per Participating Game,</strong> For A
                            Maximum Of Three Rewards.
                        </li>

                        <li>
                            Winnings Will Be Credited Directly To The Player&apos;s
                            Wallet.
                        </li>

                        <li>
                            Cancelled, Voided Or Invalid Bets Will Not Count Towards
                            The Promotion.
                        </li>

                        <li>Regular Terms & Conditions Apply.</li>
                    </TermsList>
                </Section>
            </InformationWrapper>
        </>
    );
}

export default withTheme(withAppContext(Place9BetsWinUpTo99XPromoFun));

/* =========================================================
   MAIN WRAPPER
========================================================= */

const InformationWrapper = styled.div`
    width: 100%;
    min-height: 100vh;
    height: auto;

    padding: 10px 0 35px;
    margin: 0;

    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;

    background: #eeeeee;

    overflow: hidden;
    position: relative;

    color: #292638;

    h1,
    h2,
    p {
        margin: 0;
        padding: 0;
    }

    h1,
    h2 {
        color: #252235;
        font-style: normal;
        font-weight: 700;
        text-align: center;
        line-height: normal;
    }

    h1 {
        font-size: 16px;
        text-transform: uppercase;
    }

    h2 {
        font-size: 16px;
        text-transform: capitalize;
    }

    @media (max-width: 768px) {
        padding: 10px;
        gap: 10px;

        h1 {
            font-size: 15px;
            line-height: 22px;
        }

        h2 {
            font-size: 15px;
        }
    }

    @media (max-width: 480px) {
        h1 {
            font-size: 14px;
            line-height: 21px;
        }

        h2 {
            font-size: 14px;
        }
    }
`;

/* =========================================================
   TOP SECTION
========================================================= */

const TopSection = styled.div`
    width: 76%;
    max-width: 1200px;
    min-height: 170px;

    padding: 32px 30px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    gap: 18px;

    background: #ffffff;
    border-radius: 10px;

    box-sizing: border-box;

    .top-para {
        width: 100%;
        max-width: 900px;

        color: #4c4c4c;

        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;

        text-transform: none;
    }

    .promotion-period {
        color: #555555;

        font-size: 14px;
        font-weight: 400;
        line-height: 22px;

        text-align: center;
    }

    .promotion-period strong {
        color: #333333;
        font-weight: 700;
    }

    @media (max-width: 992px) {
        width: 90%;
    }

    @media (max-width: 768px) {
        width: 100%;
        min-height: auto;

        padding: 25px 20px;

        gap: 15px;

        .top-para,
        .promotion-period {
            font-size: 13px;
            line-height: 20px;
        }

        .desktop-break {
            display: none;
        }
    }
`;

/* =========================================================
   COMMON SECTION
========================================================= */

const Section = styled.section`
    width: 76%;
    max-width: 1200px;

    padding: 25px 30px 28px;

    display: flex;
    flex-direction: column;
    align-items: center;

    background: #ffffff;
    border-radius: 10px;

    box-sizing: border-box;

    .section-description {
        margin-top: 12px;

        color: #555555;

        text-align: center;
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;

        text-transform: none;
    }

    @media (max-width: 992px) {
        width: 90%;
    }

    @media (max-width: 768px) {
        width: 100%;
        padding: 24px 15px;

        .section-description {
            margin-top: 10px;

            padding: 0 5px;

            font-size: 13px;
            line-height: 20px;
        }
    }
`;

/* =========================================================
   GAME CARDS
========================================================= */

const GamesWrapper = styled.div`
    width: 100%;
    max-width: 625px;

    margin: 14px auto 0;

    display: grid;
    grid-template-columns: repeat(3, 1fr);

    justify-content: center;
    align-items: stretch;

    gap: 16px;

    @media (max-width: 768px) {
        max-width: 580px;
        gap: 10px;
    }

    @media (max-width: 600px) {
        width: 100%;
        max-width: 240px;

        grid-template-columns: 1fr;

        gap: 14px;
    }
`;

const GameLink = styled.a`
    width: 100%;

    display: block;

    border-radius: 11px;
    overflow: hidden;

    cursor: pointer;

    text-decoration: none;

    transition:
        transform 0.2s ease,
        box-shadow 0.2s ease;

    img {
        width: 100%;
        height: auto;

        display: block;

        border-radius: 11px;
    }

    &:hover {
        transform: translateY(-3px);
        box-shadow: 0 6px 14px rgba(0, 0, 0, 0.12);
    }

    &:active {
        transform: translateY(-1px);
    }
`;

/* =========================================================
   HOW TO CLAIM IMAGE
========================================================= */

const ImageWrapper = styled.div`
    width: 72%;
    max-width: 800px;

    margin: 20px auto 0;

    display: flex;
    justify-content: center;
    align-items: center;

    img {
        width: 100%;
        height: auto;

        display: block;
    }

    @media (max-width: 992px) {
        width: 85%;
    }

    @media (max-width: 768px) {
        width: 100%;
        margin-top: 16px;
    }
`;

/* =========================================================
   TERMS & CONDITIONS
========================================================= */

const TermsList = styled.ul`
    width: 57%;
    max-width: 600px;

    display: flex;
    justify-content: center;
    align-items: stretch;
    flex-direction: column;

    gap: 8px;

    margin: 20px auto 0;
    padding: 0;

    list-style: none;

    li {
        position: relative;

        color: #555555;
        background: #eeeeee;

        font-size: 14px;
        font-style: normal;
        font-weight: 400;

        text-align: left;

        line-height: 22px;
        text-transform: none;

        padding: 8px 15px 8px 35px;

        box-sizing: border-box;
    }

    li::before {
        content: "✦";

        position: absolute;

        left: 18px;
        top: 8px;

        color: #555555;

        font-size: 11px;
    }

    li strong {
        color: #444444;
        font-weight: 700;
    }

    @media (max-width: 992px) {
        width: 70%;
    }

    @media (max-width: 768px) {
        width: 100%;

        margin-top: 16px;

        gap: 7px;

        li {
            font-size: 13px;
            line-height: 20px;

            padding: 9px 12px 9px 31px;
        }

        li::before {
            left: 13px;
            top: 9px;
        }
    }

    @media (max-width: 480px) {
        li {
            font-size: 12px;
            line-height: 19px;
        }
    }
`;